import React from "react";

// A render-time exception anywhere would unmount the whole app (blank, frozen screen
// until the user kills it). Catch it, keep the session, and offer a one-tap reload.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    try { console.error("[ErrorBoundary]", error, info?.componentStack); } catch (e) { /* ignore */ }
  }

  render() {
    if (!this.state.error) return this.props.children;
    const lang = (() => { try { return localStorage.getItem("pmf_lang") || "en"; } catch (e) { return "en"; } })();
    const txt = {
      pt: { title: "Ops, algo deu errado", body: "A tela travou por um erro inesperado. Toque para recarregar — você continua conectado.", btn: "Recarregar" },
      es: { title: "Ups, algo salió mal", body: "La pantalla falló por un error inesperado. Toca para recargar — sigues conectado.", btn: "Recargar" },
      en: { title: "Oops, something went wrong", body: "The screen hit an unexpected error. Tap to reload — you stay signed in.", btn: "Reload" },
    }[lang] || {};
    return (
      <div data-testid="error-boundary" className="min-h-screen flex flex-col items-center justify-center gap-4 p-8 text-center bg-background text-foreground">
        <h1 className="text-xl font-semibold">{txt.title}</h1>
        <p className="text-sm text-muted-foreground max-w-sm">{txt.body}</p>
        <button
          data-testid="error-boundary-reload-btn"
          onClick={() => { try { window.location.href = "/"; } catch (e) { window.location.reload(); } }}
          className="rounded-full bg-primary text-primary-foreground px-6 py-3 text-sm font-medium"
        >
          {txt.btn}
        </button>
      </div>
    );
  }
}
